import script from "./sw-item-parts-radio-check.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-radio-check.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-radio-check.vue?vue&type=style&index=0&id=f073b7d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f073b7d0"]])

export default __exports__